document.addEventListener("DOMContentLoaded", function() {
  const carousels = document.querySelectorAll(".aqi-testimonials-carousel");

  carousels.forEach(carousel => {
    const wrapper = carousel.querySelector(".testimonial-slides-wrapper");
    const slides = wrapper.querySelectorAll(".testimonial-slide");
    let current = 0;

    if (slides.length > 0) {
      setInterval(() => {
        current = (current + 1) % slides.length;
        wrapper.style.transform = `translateX(-${current * 100}%)`;
      }, 4000); // 4 seconds per slide
    }
  });
});